import { FormInput } from "@general-backoffice/core";
import type { TaxProfile } from "@investhinks/api-client";
import React from "react";
import { Card, CardBody } from "reactstrap";

type DeclarationStepTaxProfile = Pick<TaxProfile, "profileType" | "particularDeclaration" | "privateIndividualDeclaration"> & Record<string, unknown>;

interface DeclarationStepProps {
  taxProfile: DeclarationStepTaxProfile | null;
  handleInputChange: (name: string, value: unknown) => void;
  isLoading: boolean;
  t: (key: string, fallback?: string) => string;
}

const DeclarationStep = ({ taxProfile, handleInputChange, isLoading, t }: DeclarationStepProps) => {
  const isSpanishParticular = taxProfile?.profileType === "SPANISH_PARTICULAR";

  return (
    <div>
      <h5 className="mb-3">{t("steps.declaration.title", "Declaration")}</h5>
      <p className="text-muted mb-4">
        {t("steps.declaration.description", "Please confirm your status by signing the required declaration.")}
      </p>

      <Card className="bg-light">
        <CardBody>
          {isSpanishParticular ? (
            <>
              <p>
                {t(
                  "steps.declaration.particularText",
                  "I declare that I am not registered for any economic activity and I am not required to issue invoices. I understand that payments received will be considered as occasional income."
                )}
              </p>
              <FormInput.Switch
                label={t("steps.declaration.particularCheckbox", "I confirm the above declaration")}
                name="particularDeclaration"
                checked={taxProfile?.particularDeclaration || false}
                onChange={(e) => handleInputChange("particularDeclaration", e.target.checked)}
                disabled={isLoading}
              />
            </>
          ) : (
            <>
              <p>
                {t(
                  "steps.declaration.privateText",
                  "I declare that I am a private individual not performing any business or professional activity. I am not registered for VAT in any jurisdiction."
                )}
              </p>
              <FormInput.Switch
                label={t("steps.declaration.privateCheckbox", "I confirm the above declaration")}
                name="privateIndividualDeclaration"
                checked={taxProfile?.privateIndividualDeclaration || false}
                onChange={(e) => handleInputChange("privateIndividualDeclaration", e.target.checked)}
                disabled={isLoading}
              />
            </>
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default DeclarationStep;
